// extracted by mini-css-extract-plugin
export var externalLink = "_dq-0";
export var internalLinkLabel = "_dq-1";